// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ac3a28394c90643ba7d7","655":"0745ba6a9b3caf42895a"}[chunkId] + ".js";
};